export default ({ url, csrfToken, appId, apiKey }) => ({
  search(requests) {
    return fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrfToken,
      },
      credentials: 'include',
      body: JSON.stringify({ requests }),
    }).then((res) => res.json());
  },
  applicationID: appId,
  apiKey: apiKey,
});
